import { DEFAULT_BRAND } from '@vedalib/editor/lib/brand'
import { createContext } from 'use-context-selector'

import type { BrandType } from './types'

export const BrandContext = createContext<BrandType>(DEFAULT_BRAND)
BrandContext.Provider.displayName = 'BrandContext.Provider'
